// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressPf_v-icon_tqry_","nsAddressForm":"NsAddressPf_nsAddressForm_XF7aA","dualColumn":"NsAddressPf_dualColumn_2RRqy","firstCol":"NsAddressPf_firstCol_3knG9"};